module.exports = __webpack_public_path__ + "static/media/circle.b651f731.webp";